<template>
  <div class="menu-self">
    <Menu mode="horizontal" active-name="/" @on-select="selected">
      <MenuItem v-for="item in navData" :name="item.link" :key="item.key"> {{item.name}}
      </MenuItem>
    </Menu>
  </div>
</template>
<script>
import navSource from '../json/navbar'
export default {
  name: 'navBar',
  data() {
    return {
      navData: navSource.navData
    }
  },
  methods: {
    selected(value) {
      this.$router.push(value)
    }
  }
}
</script>
<style scoped lang="less">
.menu-self {
  height: 60px;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue